module.exports = __webpack_public_path__ + "static/media/callgage-about-thumbnail.4a088b86.jpg";